<template>
    <div class="notranslate">
        <mu-tabs :value.sync="active1" inverse color="#212121" indicator-color="#da5b3a" style="z-index:0;position:fixed;" @change="tabChange">
            <mu-tab>{{seller.restaurantName}}</mu-tab>
        </mu-tabs>
        <div style="position:absolute;font-size:12px;left:35%;width:60%;top:60px;">{{seller.prompt}}</div>
        <div class="demo-text" v-if="active1 === 0">
            <div class="goods notranslate">
                <div class="menu-wrapper" ref="menuWrapper">
                    <ul style="-webkit-overflow-scrolling: touch; overflow-scrolling: touch;" class="notranslate">
                            <li v-if="historyShow" class="menu-item" :class="{'current': currentMeneId==10000}" @click="selectMenu('history',10000,10000)">
                                <span class="text" style="font-weight: 600; ">{{$t('buffet.history')}}</span>
                            </li>
                            <li v-for="item in buffetPayGoodsList"  :key="item.menuFoodTypeId" class="menu-item" :class="{'current': item.menuFoodTypeId === currentMeneId}" @click="selectMenu('good',item.menuFoodTypeId)">
                                <span class="text">{{item.menuFoodTypeName}} <span class="badge-tip" v-if="item.typeTotal>0">{{item.typeTotal}}</span></span>
                                <img src="../assets/image/hot.png" v-if="item.isRecommend" style="width: 28px;position: absolute;left: 50px;margin-top:5px;"/>
                            </li>
                        </ul>
                </div>
                <div class="foods-wrapper notranslate" ref="foodsWrapper" style="background-color:#fff;">
                    <ul>
                        <li v-if="currSelectKey=='history'">
                            <h1 class="title">{{$t('buffet.history')}}</h1>
                            <div v-for="(item,index) in goods" :key="index"  class="food-list food-list-hook" >
                                <template v-for="(food,index1) in item.foodList" >
                                <div class="food-item" :key="index1" v-if="food.history==1 ">
                                    <img width="140" height="80" :src="getImgUrl(food.foodImage,200)" @click="selectFood(food)">
                                    <div class="content">
                                        <h2 class="name">{{food.foodName}}</h2>
                                        <div class="price" style="padding-top: 30px;">
                                            <span class="now">{{Number(food.price * food.actDiscount).toFixed(0)}} {{seller.unit}}</span><span v-show="food.actDiscount!=1" class="old">{{food.price}} {{seller.unit}}</span>
                                        </div>
                                        <div class="cart-wrapper">
                                            <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                        </div>
                                    
                                    </div>
                                </div>
                                </template>
                            </div>
                        </li>
                        <template v-for="item in goods" >
                        <li  class="food-list food-list-hook" :key="item.menuFoodTypeId" v-if="currentMeneId==item.menuFoodTypeId && currSelectKey=='good'">
                            <h1 class="title">{{item.menuFoodTypeName}}</h1>
                            <ul v-for="subType in subTypeList"  :key="subType.menuFoodTypeId"  class="food-item" >
                                <img width="140" height="80" :src="getImgUrl(subType.foodTypeImage,200)"  >
                                <div class="content">
                                    <h2 class="name">{{subType.menuFoodTypeName}}</h2>
                                    <div class="price" style="padding-top:30px;">
                                    </div>
                                    <div  class="cart-wrapper">
                                        <mu-badge :content="getChoice()" badge-class="badge-class"  color="#da5b3a" @click="openSelectSheet(subType.menuFoodTypeId)"></mu-badge>
                                    </div>
                                </div>
                            </ul>
                            <ul v-for="food in item.foodList"  :key="food.foodId"  class="food-item">
                                <template v-if="food.foodId>0">
                                <img width="140" height="80" :src="getImgUrl(food.foodImage,200)" @click="selectFood(food)" >
                                <div class="content">
                                    <h2 class="name">{{food.foodName}}</h2>
                                    <div class="price" style="padding-top:30px;">
                                        <span class="now">{{Number(food.price * food.actDiscount).toFixed(0)}} {{seller.unit}}</span><span v-show="food.actDiscount!=1" class="old">{{food.price}} {{seller.unit}}</span>
                                    </div>
                                    <div class="cart-wrapper">
                                        <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                    </div>
                                  </div>
                                </template>
                            </ul>
                        </li>
                    </template>
                    </ul>
                </div>
                <shopcart :select-foods="selectFoods" :add-type="payClass" :package-type="0" :is-seft="isSeft" :is-seft-pay="isSeftPay"></shopcart>
                <food :food="selectedFood" :add-type="payClass" ref="food"></food>
            </div>
        </div>
        <div style="right:0;position:absolute;bottom:50px;" v-if="unPayTip!=''">
            <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{unPayTip}}</mu-chip>
        </div>

        <mu-bottom-sheet :open.sync="selectOpen" style="overflow-y:auto;height:60%;">
            <mu-list @item-click="closeSelectSheet">
                <mu-sub-header>{{$t('orderList.selectOne')}}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon" @click="closeSelectSheet"></mu-icon>
                <div class="foods-wrapper notranslate">
                    <div v-for="(item,index0) in goods" :key="index0">
                       <div  v-if="menuId==item.menuFoodTypeId">
                        <ul v-for="food in item.foodList"  :key="food.foodId"  class="food-item"  v-if="food.foodId>0">
                                <img width="140" height="80" :src="getImgUrl(food.foodImage,200)" @click="selectFood(food)" >
                                <div class="content">
                                    <h2 class="name">{{food.foodName}}</h2>
                                    <div class="price" style="padding-top:30px;">
                                        <span class="now">{{Number(food.price * food.actDiscount).toFixed(0)}} {{seller.unit}}</span><span v-show="food.actDiscount!=1" class="old">{{food.price}} {{seller.unit}}</span>
                                    </div>
                                    <div  class="cart-wrapper">
                                        <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                    </div>
                               
                                </div>
                            </ul>
                            </div>
                     </div>
                </div>
            </mu-list>
        </mu-bottom-sheet>

        <mu-dialog title="Recommended" :open.sync="openRecommended" :overlay-close="true" id="dialogRecommended" :lock-scroll="true">
            <div class="foods-wrapper" style="overflow-y: auto;overflow-x:hidden;margin:0px;" :style="{ height: screenHeight + 'px' }">
                <div style="position:absolute;top:0px;left:0px;z-index:2021090820">
                    <img width="48" height="48" src="../assets/image/round_close.png" @click="closeRecommended">
                </div>
                <ul>
                    <li v-for="(item,index) in goods" :key="index" class="food-list food-list-hook" >
                        <div v-for="food in item.foodList" :key="food.foodId" class="food-item" v-if="food.recommended==2" style="display:block;">
                            <div class="pop"><img width="46" height="22" src="../assets/image/pop.gif"></div>
                            <div style="display: block;"><img style="width:100%" height="180" :src="getImgUrl(food.foodImage,200)"></div>
                            <div style="display: block;">
                                <h2 style="margin: 5px 0 0 10px; height: 12px; line-height: 12px; font-size: 14px; color: #07111b;">{{food.foodName}}</h2>
                                <div class="price" style="padding-top: 30px; margin-left: 10px;">
                                    <span style="font-size: 12px; color: #f01414; font-weight: 700; line-height: 24px; margin-right: 8px;">{{Number(food.price * food.actDiscount).toFixed(0)}} {{seller.unit}}</span>
                                    <span v-show="food.actDiscount!=1" style=" font-size: 12px; text-decoration: line-through; color: #93999f; font-weight: 700; line-height: 24px;">{{food.price}} {{seller.unit}}</span>
                                </div>
                                <div style=" position: absolute; right: 0; bottom: 12px;">
                                    <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div style="height: 46px; line-height: 46px; text-align: center; opacity: 0.4; background-color: rgb(0, 0, 0);color:#fff;" v-if="openRecommended" @click="closeRecommended">
                    {{$t('common.close')}}
                </div>
            </div>
        </mu-dialog>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import shopcart from '../components/ShopCart'
    import cartcontrol from '../components/CartControl'
    import food from '../components/Food'
    import seller from '../components/Seller'
    import Vue from 'vue'

    export default {
        inject: ['reload'],
        props: {
            isSeft: {
                type: Number,
                default: 0
            },
            isSeftPay: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                seller: {},
                currSelectKey:'',
                currentMeneId: 1,
                active1: 0,
                goodsSourcs: [],
                goods: [],
                listHeight: [],
                scrollY: 0,
                selectedFood: {},
                curIndex: 0,
                panel: 0,
                selectOpen: false,
                childLists: [],
                parentId: 0,
                recommendeds: [],
                openRecommended: false,
                screenHeight: document.documentElement.clientHeight - 60,
                isFrist: true,
                tableOrderInfo: {
                    name:"admin",
                    telephone:"00000000",
                    tableName:"01"
                },
                cartList:[],
                configsData: {},
                order: {},
                unPayTip: '',
                historyShow: false,
                openOrderChange:false,
                timer: null,
                once: 0,
                menuId:0,
            }
        },
        computed: {
            payClass() {
                if (this.order != null) {
                    var personNum = this.order.adult== undefined ? 1 : this.order.adult;
                    if(this.order.child != undefined && this.order.child != null && this.order.child!='' ) {
                        personNum = personNum + parseInt(this.order.child);
                    }
                    var everybodyCopies = 20;
                    if (this.configsData.EverybodyCopies != null) {
                        everybodyCopies = parseInt(this.configsData.EverybodyCopies.toString());

                        var curEverybodyCopies = 0;
                        var curTotalSeveral = 0;
                        this.selectFoods.forEach((item) => {
                            curEverybodyCopies = item.quantity;
                            curTotalSeveral += parseInt(item.several * item.quantity);
                            this.cartList.forEach((rowData) => {
                                if (rowData.foodId == item.foodId) {
                                    curEverybodyCopies = curEverybodyCopies + rowData.quantity;
                                }
                            });
                            if ((item.perMaxCopies > 0 && (curEverybodyCopies >= (item.perMaxCopies * personNum))) || item.perMaxCopies == null) {
                                this.unPayTip = this.$t('orderList.onePersonOrder', { num: item.perMaxCopies}) +' ' + item.foodName
                                item.unAdd = true;
                                item.unPayTip = this.$t('orderList.onePersonOrder', { num: item.perMaxCopies})
                            }
                            else {
                                item.unAdd = false;
                            }
                        })
                        if (curTotalSeveral >= (everybodyCopies * personNum)) {
                            this.unPayTip = this.$t('orderList.timeLimit', { num: (everybodyCopies * personNum) } );
                            return true;
                        }
                    }
                }
                this.unPayTip = '';
                return false;
            },
            selectFoods() {
                let foods = [];
                this.goods.forEach((good) => {
                    good.foodList.forEach((food) => {
                        if (food.quantity) {
                            foods.push(food);
                        }
                    })
                })
                // if (this.childLists.length > 0) {
                //     this.childLists.forEach((food) => {
                //         if (food.quantity) {
                //             foods.push(food);
                //         }
                //     })
                // }
                return foods
            },
            buffetPayGoodsList(){
                return this.buffetPayGoods.filter((item)=>item.menuId==0)
            },
            subTypeList(){
                return this.goods.filter((item)=>item.menuId==this.currentMeneId)
            },
            buffetPayGoods() {
                let typeTotal = 0;
                var payGoods = [];
                this.goods.forEach((good) => {
                    typeTotal = 0;
                    good.foodList.forEach((food) => {
                        if (food.quantity) {
                            typeTotal += food.quantity;
                        }
                    })
                    good.typeTotal = typeTotal;
                    payGoods.push(good);
                })
                   //累加子分类的数量
                   payGoods.forEach((item1) => {
                    if(item1.menuId==0){
                        let typeTotal0=0;
                        payGoods.forEach((item2) => {
                            if(item1.menuFoodTypeId==item2.menuId){
                                typeTotal0+=item2.typeTotal;
                            }
                        })
                        item1.typeTotal +=typeTotal0;
                    }
                })
                return payGoods
            },
        },
        created() {
        },
        mounted() {
            this.tableOrderInfo=this.getItem('sessionStorage', 'tableOrderInfo');
            this.initData();
          
         
        },
        methods: {
            initData() {
                this.isFrist = false;
                this.curIndex = 0;
                this.getMenuList();
                this.getConfigs();
                this.getRestaurantInfo();
            },
            getRestaurantInfo() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeBasicInfo/GetRestaurant', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.seller = response.data;
                            window.localStorage.setItem('seller', JSON.stringify(this.seller)) 
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            removeTip(index) {
                this.unPayTip = "";
            },
            async getConfigs() {
                await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            goTop() {
                window.scrollTo(0, 0);
            },
            getChoice() {
                return this.$t('orderList.choice');
            },
            toggle(panel) {
                this.panel = panel === this.panel ? 0 : panel;
            },
            _initScroll() {
                this.menuScroll = new BScroll(this.$refs.menuWrapper, {
                    click: true,
                })
                this.foodsScroll = new BScroll(this.$refs.foodsWrapper, {
                    click: true,
                    probeType: 1
                })
                this.foodsScroll.on('scroll', (pos) => {
                    this.scrollY = Math.abs(Math.round(pos.y));
                })
            },
            _calculateHeight() {
                let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook')
                let height = 0
                this.listHeight.push(height)
                for (let i = 0; i < foodList.length; i++) {
                    let item = foodList[i]
                    height += item.clientHeight
                    this.listHeight.push(height)
                }
            },
            closeSelectSheet() {
                this.selectOpen = false;
            },
            openSelectSheet(menuId) {
                this.menuId=menuId;
                this.selectOpen = true;
            },
            tabChange(value) {
            },
            selectMenu(key, foodTypeId) {
                this.currSelectKey=key;
                this.currentMeneId = foodTypeId;
                //let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
                //let ref = foodList[0];
                this.$refs.foodsWrapper.scrollTop = 0;
            },
            selectFood(food) {
                this.selectedFood = food;
                this.$refs.food.show();
            },
            getMenuList() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    clientId: 1
                };
                this.$get('QRCodeOrder/GetMenuFoodList', param)
                    .then(response => {
                        if (response.code==200) {
                            this.goods = response.data;
                            if (this.goods.length > 0) {
                                this.currentMeneId = this.goods[0].menuFoodTypeId;
                                if(this.tableOrderInfo.currentMenuId!=undefined && this.tableOrderInfo.currentMenuId!=null){
                                    this.currentMeneId = this.tableOrderInfo.currentMenuId;
                                }
                                this.selectMenu('good',this.currentMeneId);
                            }
                            if(this.tableOrderInfo.subMenuId!=undefined && this.tableOrderInfo.subMenuId!="0"){
                                    this.openSelectSheet(this.tableOrderInfo.subMenuId);
                                }
                        } else {
                            this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                        }
                    });
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            closeRecommended() {
                this.openRecommended = false;
            },
            getPath() {
            
            }
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            shopcart,
            cartcontrol,
            food,
            seller
        }
    }
</script>
<style scoped>
    #dialogRecommended >>> .mu-dialog {
        min-width: 90% !important;
    }

    #dialogRecommended >>> .mu-dialog-body {
        padding: 0 !important;
    }

    #dialogRecommended >>> .mu-dialog-title {
        background-color: #93999f;
        padding:0;
        color: #fff;
        display:none;
    }
    </style>
    <style lang="stylus" rel="stylesheet/stylus" >
    .goods {
        position: fixed;
        bottom: 44px;
        width: 100%;
        max-width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        overflow: hidden;
        background-color: #f5f5f5;
        margin-top: 30px;
    }

        .goods .menu-wrapper {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 90px;
            flex: 0 0 90px;
            background: #f5f5f5;
            overflow-y: auto;
        }

            .goods .menu-wrapper::-webkit-scrollbar {
                width: 0px;
                background: #f5f5f5;
            }

            .goods .menu-wrapper .menu-item {
                width: 100%;
                height: 48px;
                line-height: 48px;
                display: table;
                padding: 0 8px;
                margin: 0 auto;
                background: #f5f5f5;
                position: relative;
            }

                .goods .menu-wrapper .menu-item.current {
                    position: relative;
                    background: #fff;
                    font-weight: 700;
                    margin-top: -1px;
                    z-index: 100;
                }

                    .goods .menu-wrapper .menu-item.current .text:after {
                        border-top: 0;
                    }

                .goods .menu-wrapper .menu-item:last-child .text:after {
                    border-top: none;
                }



                .goods .menu-wrapper .menu-item .text {
                    display: inline-block;
                    vertical-align: middle;
                    position: relative;
                    width: 100%;
                    font-size: 12px;
                    float: left;
                    height: 56px;
                    font-weight: 600;
                    line-height: 56px;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: normal !important;
                }

                    .goods .menu-wrapper .menu-item .text:after {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        border-top: 1px solid rgba(7,17,27,0.1);
                        content: '';
                    }

                    .goods .menu-wrapper .menu-item .text .icon {
                        vertical-align: top;
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        margin-right: 4px;
                        background-size: 12px 12px;
                        background-repeat: no-repeat;
                    }

        .goods .foods-wrapper {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
        }

            .goods .foods-wrapper h1 {
                margin: 0px;
            }

            .goods .foods-wrapper .title {
                padding-left: 14px;
                border-left: 2px solid #d9dde1;
                font-size: 12px;
                height: 26px;
                line-height: 26px;
                color: #93999f;
                background-color: #f3f5f7;
            }

            .goods .foods-wrapper .food-item {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                margin: 5px;
                padding-bottom: 10px;
                margin-right: 10px;
                position: relative;
            }

                .goods .foods-wrapper .food-item:after {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-top: 1px solid rgba(7,17,27,0.1);
                    content: '';
                }

                .goods .foods-wrapper .food-item:last-child:after {
                    border-top: 0;
                }

                .goods .foods-wrapper .food-item .icon {
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 57px;
                    flex: 0 0 57px;
                    margin-right: 10px;
                }

                .goods .foods-wrapper .food-item .content {
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    margin-left: 5px;
                }

                    .goods .foods-wrapper .food-item .content .name {
                        margin: 2px 0 8px 0;
                        height: 12px;
                        line-height: 12px;
                        font-size: 14px;
                        color: #07111b;
                    }

                    .goods .foods-wrapper .food-item .content .description,
                    .goods .foods-wrapper .food-item .content .extra {
                        font-size: 10px;
                        line-height: 10px;
                        color: #93999f;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                        height: 10px;
                        line-height: 10px;
                    }

                        .goods .foods-wrapper .food-item .content .extra .count {
                            margin-right: 12px;
                            line-height: 10px;
                        }

                        .goods .foods-wrapper .food-item .content .extra .rating {
                            line-height: 10px;
                        }

                    .goods .foods-wrapper .food-item .content .price .now {
                        font-size: 12px;
                        color: #f01414;
                        font-weight: 700;
                        line-height: 24px;
                        margin-right: 8px;
                    }

                    .goods .foods-wrapper .food-item .content .price .old {
                        font-size: 12px;
                        text-decoration: line-through;
                        color: #93999f;
                        font-weight: 700;
                        line-height: 24px;
                    }

                    .goods .foods-wrapper .food-item .content .cart-wrapper {
                        position: absolute;
                        right: 0;
                        bottom: 12px;
                    }


    .mu-icon-button {
        line-height: 1;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
    }

    .badge-tip {
        font-size: 10px;
        color: #f01414;
        font-weight: 600;
        position: absolute;
        right: 0px;
        top: -12px;
    }

    .mu-expansion-panel__expand {
        margin: 0px;
    }

        .mu-expansion-panel__expand .mu-expansion-panel-header {
            min-height: 32px;
        }

    .mu-expansion-panel-header {
        padding: 0px;
        padding-left: 5px;
        width: 100%;
        font-size: 12px;
        word-break: break-all;
        word-wrap: break-word;
        background-color: #93999f;
        color: #fff;
        min-height: 32px;
    }

    .mu-expansion-panel {
        color: rgba(0,0,0,.87);
    }

    .mu-expansion-panel-content {
        padding: 0px;
    }

    .mu-expansion-toggle-btn svg {
        width: 14px;
        height: 14px;
        fill: currentColor;
        -ms-flex-negative: 0;
        flex-shrink: 0;
    }

    .mu-icon-button {
        line-height: 1;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
    }

    .plan-pay-part {
        color: #da5b3a;
    }

    .plan-free-part {
        color: #4caf50;
    }
        .pop {
            position: absolute;
            top: 15px;
            right: 0px;
            transform: rotate(38deg);
            -o-transform: rotate(38deg);
            -webkit-transform: rotate(38deg);
            -moz-transform: rotate(38deg);
        }

        .badge-class {
            font-size: 16px;
        }
</style>



// WEBPACK FOOTER //
// src/components/GoodsShow.vue